/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 *
 * Tables Hooks
 *
 * Barrel export for all table-related hooks
 */

// PERFORMANCE: Explicit exports instead of export * for better tree-shaking

// List page state
export type {
  UseListPageStateConfig,
  UseListPageStateReturn,
} from "./use-list-page-state";
export { useListPageState } from "./use-list-page-state";

// Table preferences
export type { TableDensity, TablePrefs } from "./use-table-preferences";
export { useTablePreferences } from "./use-table-preferences";
